import { createVariablesStorage } from './storage';
const CONST_NAME = '__KARTE_BLOCKS_RESOLVED_VARIABLES';
const EVENT_NAME = 'KARTE::BLOCKS::RESOLVE_VARIABLES';
const TIMEOUT_MS = 5000;
export function createActionVariableReceiver({ window: window, storageKey, }) {
    const prevVariables = (() => {
        const variablesStorage = createVariablesStorage({
            storage: window.localStorage,
            key: storageKey,
        });
        return variablesStorage.get() ?? {};
    })();
    const latestVariablesPromise = (() => {
        const variables = window[CONST_NAME];
        if (variables) {
            return Promise.resolve(variables);
        }
        else {
            return Promise.race([
                new Promise(resolve => {
                    window.addEventListener(EVENT_NAME, () => {
                        const variables = window[CONST_NAME];
                        resolve(variables ?? {});
                    });
                }),
                new Promise(resolve => setTimeout(() => resolve({}), TIMEOUT_MS)),
            ]);
        }
    })();
    latestVariablesPromise.then(latestVariables => {
        const variablesStorage = createVariablesStorage({
            storage: window.localStorage,
            key: storageKey,
        });
        variablesStorage.set(latestVariables);
    });
    return {
        getPrev() {
            return prevVariables;
        },
        async getLatest() {
            return await latestVariablesPromise;
        },
    };
}
